import React, { useState, useEffect, useReducer } from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import MinimizeIcon from '@material-ui/icons/Minimize';
import AddIcon from '@material-ui/icons/Add';

import { toast } from "react-toastify";

import usePlans from "../../../hooks/usePlans";
import useCompanies from "../../../hooks/useCompanies";

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  margin: {
    margin: theme.spacing(1),
  },


  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },

  customCard: {
    display: "flex",
    marginTop: "16px",
    alignItems: "center",
    flexDirection: "column",
  },
  custom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }
}));


export default function Pricing(props) {
  const {
    setFieldValue,
    setActiveStep,
    activeStep,
    Invoice,
  } = props;

  const handleChangeAdd = (event, newValue) => {
    if (newValue < 3) return

    const newPrice = 11.00;

    setUsersPlans(newValue);
    setCustomValuePlans(customValuePlans + newPrice);
  }

  const handleChangeMin = (event, newValue) => {
    if (newValue < 3) return

    const newPrice = 11;

    setUsersPlans(newValue);
    setCustomValuePlans(customValuePlans - newPrice);
  }

  const handleChangeConnectionsAdd = (event, newValue) => {
    if (newValue < 3) return
    const newPrice = 20.00;
    setConnectionsPlans(newValue);
    setCustomValuePlans(customValuePlans + newPrice);
  }

  const handleChangeConnectionsMin = (event, newValue) => {
    if (newValue < 3) return
    const newPrice = 20;
    setConnectionsPlans(newValue);
    setCustomValuePlans(customValuePlans - newPrice);
  }

  const { list, finder } = usePlans();
  const { find } = useCompanies();

  const classes = useStyles();
  const [usersPlans, setUsersPlans] = React.useState(3);
  const [companiesPlans, setCompaniesPlans] = useState(0);
  const [connectionsPlans, setConnectionsPlans] = React.useState(3);
  const [storagePlans, setStoragePlans] = React.useState([]);
  const [customValuePlans, setCustomValuePlans] = React.useState(49.00);
  const [loading, setLoading] = React.useState(false);
  const companyId = localStorage.getItem("companyId");

  useEffect(() => {
    async function fetchData() {
      await loadCompanies();
    }
    fetchData();
  }, [])

  // Monta um "tier" a partir da própria fatura. Usado quando o plano vinculado
  // à empresa não existe mais (plano antigo/removido): a fatura já contém a
  // descrição e o valor a pagar, então ainda é possível gerar o PIX.
  const buildTierFromInvoice = () => {
    if (!Invoice || Invoice.value == null) return null;
    return {
      title: Invoice.detail || "Fatura em aberto",
      planId: null,
      price: Invoice.value,
      description: [
        `Fatura #${Invoice.id}`,
        "Regularização da licença",
      ],
      // Backend exige users/connections; a fatura não os armazena. Enviamos os
      // valores atuais da empresa apenas para satisfazer a validação — eles não
      // alteram o plano, apenas geram a cobrança do valor da fatura.
      users: usersPlans,
      connections: connectionsPlans,
      queues: 0,
      buttonText: 'PAGAR FATURA',
      buttonVariant: 'contained',
    };
  };

  const loadCompanies = async () => {
    setLoading(true);
    try {
      let plan = null;
      try {
        const companiesList = await find(companyId);
        setCompaniesPlans(companiesList.planId);
        if (companiesList.planId) {
          plan = await finder(companiesList.planId);
        }
      } catch (e) {
        // Empresa inacessível ou plano antigo/inexistente — tratamos abaixo
        // com o fallback baseado na fatura.
        console.log(e);
      }

      if (plan) {
        setStoragePlans([
          {
            title: plan.name,
            planId: plan.id,
            price: plan.value,
            description: [
              `${plan.users} Usuários`,
              `${plan.connections} Conexão`,
              `${plan.queues} Filas`,
            ],
            users: plan.users,
            connections: plan.connections,
            queues: plan.queues,
            buttonText: 'SELECIONAR',
            buttonVariant: 'outlined',
          },
        ]);
        return;
      }

      const fallback = buildTierFromInvoice();
      if (fallback) {
        setStoragePlans([fallback]);
        return;
      }

      toast.error(
        "Nenhum plano ou fatura disponível para pagamento. Contate o suporte."
      );
    } finally {
      setLoading(false);
    }
  };


  const tiers = storagePlans
  return (
    <React.Fragment>
      {!loading && tiers.length === 0 && (
        <Typography
          align="center"
          color="textSecondary"
          style={{ padding: "24px 0" }}
        >
          Nenhum plano disponível para pagamento no momento. Atualize a página
          ou entre em contato com o suporte.
        </Typography>
      )}
      <Grid container spacing={3}>
        {tiers.map((tier) => (
          // Enterprise card is full width at sm breakpoint
          <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 12} md={12}>
            <Card>
              <CardHeader
                title={tier.title}
                subheader={tier.subheader}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={tier.title === 'Pro' ? <StarIcon /> : null}
                className={classes.cardHeader}
              />
              <CardContent>
                <div className={classes.cardPricing}>
                  <Typography component="h2" variant="h3" color="textPrimary">
                    {

                      <React.Fragment>
                        R${tier.price.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                      </React.Fragment>
                    }
                  </Typography>
                  <Typography variant="h6" color="textSecondary">
                    /mês
                  </Typography>
                </div>
                <ul>
                  {tier.description.map((line) => (
                    <Typography component="li" variant="subtitle1" align="center" key={line}>
                      {line}
                    </Typography>
                  ))}
                </ul>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant={tier.buttonVariant}
                  color="primary"
                  onClick={() => {
                    if (tier.custom) {
                      setFieldValue("plan", JSON.stringify({
                        users: usersPlans,
                        connections: connectionsPlans,
                        price: customValuePlans,
                      }));
                    } else {
                      setFieldValue("plan", JSON.stringify(tier));
                    }
                    setActiveStep(activeStep + 1);
                  }
                  }
                >
                  {tier.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}